"use client";

import { useMemo } from "react";
import type { MindstringPrototype, Situation } from "@/generated/fastapi";
import { filterSituationsByPrototypes } from "../utils";
import useSituationItems from "./useSituationItems";

export default function useAssignableSituations(
  situations: Situation[] | null | undefined,
  prototypes: MindstringPrototype[],
) {
  const assignableSituations = useMemo(
    () => filterSituationsByPrototypes(situations ?? [], prototypes),
    [prototypes, situations],
  );
  const assignableSituationItems = useSituationItems(assignableSituations);

  return {
    items: assignableSituationItems,
    situations: assignableSituations,
  };
}
